import React from 'react';
import { StyleSheet, css } from 'aphrodite';

// MATERIAL
import Hidden from '@material-ui/core/Hidden'

import LeftMirror from '../../../assets/StandAlone/LeftMirror.png'

export default class SkewBg extends React.Component{

  render(){
    return(
    	<div className={css(styles.mainContainer)}>
            <section className={css(styles.skewIntro)}>
            </section>
                <Hidden smDown>
                    <div className={css(styles.mirrorContainer)}>
                        <img className={css(styles.LeftMirror)} src={LeftMirror} alt=""/>
                    </div>
                </Hidden>
        </div>
    )
  }
}

const styles = StyleSheet.create({
    mainContainer : {
        position: 'relative',
    },
    skewIntro: {
        position: 'absolute',
        zIndex: -1,
        top: 0,
        width: '100vw',
        height: 1500,
        overflow: 'hidden',
        transform: 'skewY(12deg)',
        transformOrigin: 0,
        background: 'linear-gradient(-69deg, #FF6B4D, #D85944)',
    },
    mirrorContainer: {
        position: 'absolute',
        top: 420,
        left: 0,
        height: 400,
        zIndex: -1,
    },
    LeftMirror : {
        height: 'inherit',
        filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.14)) drop-shadow(0 10px 20px rgba(0,21,64,.14))'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/StandAloneSolutions/SkewBg.js